<template>
<!-- 侧边栏小助手 -->
<div class="assistant flex-col-center">
  <button class="item" v-for="(item, i) in list" :key="i" @click="turnPage(item.url)" tabindex="0">
    <img :src="item.imgSrc" alt="">
    <p>{{item.name}}</p>
  </button>
</div>
</template>

<script>
import evaluateImg from "../assets/imgs/evaluate.png"
import officeListImg from "../assets/imgs/officeList.png"
export default {
  data() {
    return {
      list: [
      {
        name: "我要评价",
        imgSrc: evaluateImg,
        url: "http://tysb.zjwsbs.gov.cn/ApprApplyWorkPCv2/managerCenter.html#/myItems/myControlSeq?type=eva"
      }, 
      {
        name: "我的办件",
        imgSrc: officeListImg,
        url: "http://tysb.zjwsbs.gov.cn/ApprApplyWorkPCv2/managerCenter.html#/myItems/myControlSeq"
      }]
    }
  },
  methods: {
    turnPage(url) {
      url && window.open(url);
    }
  }
}
</script>

<style lang="scss" scoped>
.assistant {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
  background: #fff;

  .item {
    padding: 11px 12px 10px;
    border: 1px solid #D5D5D5;
    font-size: 14px;
    color: #727475;
    line-height: 21px;
    text-align: center;
    cursor: pointer;

    img {
      width: 32px;
      height: 32px;
    }

    &+.item {
      border-top: 0;
      padding-top: 12px;
    }
  }
}
</style>
